// assets
import { DashboardOutlined } from '@ant-design/icons';

// icons
const icons = {
    DashboardOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //
const children = [
    {
        id: 'analytics',
        title: 'Analytics',
        type: 'collapse',
        url: '#',
        breadcrumbs: false,
        children: [
            // {
            //     id: 'user',
            //     title: 'User',
            //     type: 'item',
            //     url: '/dashboard/user-analytics',
            //     breadcrumbs: false
            // },
            // {
            //     id: 'organization',
            //     title: 'Organization',
            //     type: 'item',
            //     url: '/dashboard/organization-analytics',
            //     breadcrumbs: false
            // },
            {
                id: 'engagementProfiler',
                title: 'Engagement Profiler',
                type: 'item',
                url: '/dashboard/self-profile',
                breadcrumbs: false
            },
            {
                id: 'engagementComparison',
                title: 'Engagement Comparison',
                type: 'item',
                url: '/dashboard/compare-users',
                breadcrumbs: false
            }
        ]
    }
];
const analytics = {
    id: 'analytics',
    title: 'Analytics',
    type: 'group',
    icon: icons.MedicineBoxOutlined,
    children: children
};

export default analytics;
